<label>{{ filter.label }}</label>
<div class="d-inline-flex">
  <select [(ngModel)]="filter.operator" class="form-control" (ngModelChange)="filterChange.emit(filter)">
    <option value="equals">est exactement</option>
  </select>
  <div class="ml-2">
    <select *ngIf="transporterMembers" [(ngModel)]="filter.tempValue" class="form-control" (ngModelChange)="prepareAndEmit(filter)">
      <option *ngFor="let transporterMember of transporterMembers" [value]="transporterMember.id">{{ transporterMember.firstName }} {{ transporterMember.lastName }}</option>
    </select>
  </div>
</div>
